import { createRoute, useParams } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const TemplateEditor = lazy(async () => {
  const m = await import("@/features/templates/components/template-editor");
  return { default: m.TemplateEditor };
});

function TemplateEditorPage() {
  const params = useParams({ from: "/_app/templates/$templateId" });
  return (
    <Suspense fallback={null}>
      <TemplateEditor templateId={params().templateId} />
    </Suspense>
  );
}

export interface TemplateEditorSearch {
  /** Deep-link: open the item dialog — `new` to create, an id to edit. */
  item?: string;
  /** Deep-link: pre-select the section a new item is added to. */
  section?: string;
}

export const templateDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/templates/$templateId",
  validateSearch: (search: Record<string, unknown>): TemplateEditorSearch => ({
    item: typeof search.item === "string" ? search.item : undefined,
    section: typeof search.section === "string" ? search.section : undefined,
  }),
  component: TemplateEditorPage,
});
